import { LockOpenVariantIcon } from './LockOpenVariantIcon';

/**
 * author: GreenTurtwig
 * id 4171E1EE-CA1A-4885-B41B-3EAE135BA8FE
 * name lock-open-variant
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-variant.svg
 * tags
 * - Lock 
 * - Home Automation 
 */
export const UnlockedVariantIcon = LockOpenVariantIcon;
export default UnlockedVariantIcon